/* eslint no-unused-expressions: 0 */
import { injectGlobal } from 'styled-components'
import { lighten } from 'polished'

import { BLACK, WHITE } from 'src/styles/colors.js'

export default function injectGlobaltyles() {
  injectGlobal`
    @font-face {
      font-family: 'Asap';
      font-styled: normal;
      font-weight: normal;
      src: url('/fonts/Asap-Regular.ttf');
    }

    @font-face {
      font-family: 'Asap';
      font-styled: normal;
      font-weight: bold;
      src: url('/fonts/Asap-Bold.ttf');
    }

    html,
    body {
      margin: 0;
      padding: 0;
    }

    body {
      background: ${WHITE};
      background-image: linear-gradient(to bottom, ${lighten(
        0.05,
        WHITE
      )}, ${WHITE} 700px);
      font-family: 'Asap', sans-serif;
      color: ${BLACK};
      line-height: 1.5;
      -webkit-font-smoothing: antialiased;
    }
  `
}
